<div class="card__section">
  <div class="row">
    <div class="columns">
      <h3 class="typography--subheader">Upload File</h3>
    </div>
    <div class="columns text-right">
      <button class="btn btn--hollow btn--tiny" (click)="onDownloadTemplate()">
        <i class="fa fa-download" aria-hidden="true"></i> Download Template
      </button>
    </div>
  </div>

  <!-- Modern File Upload Zone -->
  <div class="file-upload-zone" [class.has-file]="selectedFile" [class.is-drag-over]="isDragOver" (click)="triggerFileInput()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <input
      type="file"
      class="file-upload-input"
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      (change)="onFileChange($event)"
      id="fileUpload"
      #fileInput
    />
    <div class="file-upload-content" *ngIf="!selectedFile">
      <div class="file-upload-icon">
        <i class="fa fa-cloud-upload" aria-hidden="true"></i>
      </div>
      <p class="file-upload-text">Drag and drop your file here, or <span class="file-upload-browse">browse</span></p>
      <p class="file-upload-hint">Supports CSV and Excel files (.csv, .xlsx, .xls)</p>
    </div>
    <div class="file-upload-content file-selected" *ngIf="selectedFile">
      <div class="file-upload-icon">
        <i class="fa fa-file-excel-o" aria-hidden="true"></i>
      </div>
      <p class="file-upload-text file-name">{{ fileName }}</p>
      <button class="btn btn--hollow btn--tiny file-clear-btn" (click)="clearFile(); $event.stopPropagation();">
        <i class="fa fa-times" aria-hidden="true"></i> Remove
      </button>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="row u-m-t-20" *ngIf="selectedFile">
    <div class="columns">
      <div class="btn-group">
        <button
          class="btn btn--primary"
          (click)="onValidate()"
        >
          <i class="fa fa-check-circle" aria-hidden="true"></i> Validate File
        </button>
      </div>
    </div>
  </div>
</div>